import React                 from 'react';
import { connect }           from 'react-redux';
import { reduxForm,
         Field,
         formValueSelector } from 'redux-form';
import { TextField,
         Select,
         RadioLabels,
         Rating,
         Captcha }           from 'theme/Form';
import { required,
         numeric,
         email }             from 'theme/utils/validate';
import { options,
         agreements }        from 'theme/content';
import { getMosOptions }     from 'theme/content/mosOptions';

import './Form.sass';


export default connect(
  (state, props) => ({serviceBranchValue: formValueSelector(props.form)(state, 'reviewerDetails.serviceBranch')})
)(reduxForm({
  form: 'ProgramReviewForm',
  enableReinitialize: true
})(
  ({handleSubmit, pristine, submitting, searchEducators, educators, loadingEducators, invalid, submitFailed, openModal, profile, editDisabled, getAutocomplete, serviceBranchValue}) => {
    const isSpouse = serviceBranchValue === 'Spouse';
    return (
      <div className="ProgramReview__form">
        <h4>Student Experience</h4>
        <form onSubmit={handleSubmit}>
          <h6>Program Details</h6>
          <Field
            name="educator"
            label="School Name"
            required
            placeholder="Start typing..."
            component={Select}
            search={searchEducators}
            loading={loadingEducators}
            options={educators}
            valueKey='id'
            labelKey='name'
            validate={required}
            creatable
            onNewOptionClick={openModal}
            disabled={editDisabled}
            async
            getAutocomplete={getAutocomplete}
          />
          <Field
            name="programName"
            label="Program Name"
            required
            placeholder="e.g. Criminal Justice"
            component={TextField}
            validate={required}
          />
          <Field
            name="acquiredDegree"
            label="Degree Level"
            className="block"
            required
            placeholder="e.g. Associate, Bachelor's, Certificate - Undergrad"
            component={RadioLabels}
            options={options.degrees}
            validate={required}
            disabled={editDisabled}
          />
          <Field
            name="instructionDetails"
            label="Instruction Delivery"
            className="block"
            required
            component={RadioLabels}
            options={options.instructionRange}
            validate={required}
            disabled={editDisabled}
          />
          <h6>Experience Overview</h6>
          <Field
            name="review.reviewTitle"
            label="Review Title"
            placeholder="e.g. This program was perfect for my goals!"
            className="block"
            required
            component={TextField}
            validate={required}
          />
          <Field
            name="review.reviewComments"
            label="Review Comments"
            className="block"
            placeholder="How was your experience? Did you like the school and the program? Did the education result in what you wanted, e.g. a better paying job, a new function or industry, etc? Did you like how the instruction was delivered, e.g. on-line? Describe the funding sources you used, e.g. DOD TA, VA GI Bill, state-centric programs, etc. How was the quality and the culture?"
            required
            componentType="textarea"
            component={TextField}
            validate={required}
          />
          <Field
            name="rating"
            label="Rate your overall experience"
            required
            validate={required}
            component={Rating}
            disabled={editDisabled}
          />
          <h6>Funding Details</h6>
          <Field
            name="fundingDetails.fundingRange"
            label="Main Funding Benefit Used"
            className="block"
            component={RadioLabels}
            required
            options={options.fundingRange}
            validate={required}
            disabled={editDisabled}
          />
          <Field
            name="fundingDetails.spentOnEducation"
            label="About how much did you spend out of own pocket on tuition and fees (monthly)?"
            className="ProgramReview__amount"
            placeholder="$"
            required
            component={TextField}
            validate={[numeric, required]}
          />
          <h6>Quality & Culture Details</h6>
          <Field
            name="programOpinion.campusQuality"
            label="Overall, I thought the quality of the campus, staff, faculty, instruction, and resources was:"
            className="block"
            required
            component={RadioLabels}
            options={options.experienceOptions}
            validate={required}
            disabled={editDisabled}
          />
          <Field
            name="programOpinion.campusSocialLifeQuality"
            label="Overall, I thought the student culture was: "
            className="block"
            required
            component={RadioLabels}
            options={options.experienceOptions}
            validate={required}
            disabled={editDisabled}
          />
          <h6>Recommendation</h6>
          <Field
            name="recommendation"
            label="Would you recommend this program to other veterans and military spouses?"
            className="block"
            required
            component={RadioLabels}
            options={options.complete}
            validate={required}
            disabled={editDisabled}
          />
          <h6>Reviewer Information</h6>
          <Field
            name="reviewerDetails.serviceBranch"
            label="Service Branch"
            required
            className="block"
            component={RadioLabels}
            options={options.branchRange}
            validate={required}
            disabled={editDisabled}
          />
          {!isSpouse &&
            <Field
              label="Military Occupation"
              name="reviewerDetails.mos"
              placeholder="Select"
              component={Select}
              options={getMosOptions(serviceBranchValue)}
              disabled={editDisabled}
              {...(!isSpouse && {validate: required, required: true})}
            />
          }
          {!isSpouse &&
            <Field
              name="reviewerDetails.etsPaygrade"
              label="Highest Paygrade Attained"
              placeholder="Select"
              component={Select}
              options={options.paygradeOptions}
              disabled={editDisabled}
              {...(!isSpouse && {validate: required, required: true})}
            />
          }
          <Field
            name="reviewerDetails.email"
            label="Your E-mail"
            required
            placeholder="e.g. sgt.hooah@gmail.com or iam.t.standard4.mil@mail.mil"
            component={TextField}
            validate={[required, email]}
            disabled={editDisabled}
          />
          <h5 className="ProgramReview__agreement">{agreements.certifiedVet}</h5>
          {Object.keys(profile).length == 0 &&
            <Field
              name="captcha"
              component={Captcha}
              validate={required}
            />
          }
          {submitFailed && invalid &&
            <div className="ProgramReview__error">Please check if you filled all required fields.</div>
          }
          <button
            type="submit"
            className="btn-primary"
            disabled={pristine || submitting}
          >
            VET IT FORWARD!
          </button>
        </form>
      </div>
    )
  }
))
